import { render, staticRenderFns } from "./UsuarioMostrar.vue?vue&type=template&id=783fca36"
import script from "./UsuarioMostrar.vue?vue&type=script&lang=js"
export * from "./UsuarioMostrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports